import { Label, TextField } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { usePropertyContext } from "../../context";
import ButtonV2 from "elements/ButtonV2";

const OwnershipPercent = () => {
	const {
		next,
		ownerOneValue,
		ownerTwoValue,
		setOwnerOneValue,
		setOwnerTwoValue,
		additionalOwnerFirstNameValue,
		ownersValue,
	} = useExemptionsContext();
	const { details } = usePropertyContext();
	const trackEvent = useEventTracker();

	const handleSubmit = async () => {
		trackEvent({
			eventName: constants.EVENTS.Exemptions_Flow_Ownership_Percentage_Answer,
			data: {
				"Ownership Percentage": `${ownerOneValue}, ${ownerTwoValue}`,
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			"Ownership Percentage": `${ownerOneValue}, ${ownerTwoValue}`,
		};
		next({ trackingEventData });
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					<p>Ownership Percentages</p>
				</div>
				<p className="exemption-question-card-subtitle sm">
					Married couples are considered to both have 100% ownership.
				</p>
				<div className="exemption-ownership-field-container">
					<div>
						<Label className="exemption-ownership-field-input-label">
							Your Ownership %
						</Label>
						<div className="exemption-ownership-field-input-wrapper">
							<TextField
								required
								placeholder={ownersValue === "Own With Spouse" ? "100" : "50"}
								type="number"
								maxLength={3}
								value={ownerOneValue === 0 ? "" : ownerOneValue ?? ""}
								onChange={e => {
									if (e.target.value.length <= 3) {
										setOwnerOneValue(parseInt(e.target.value) || 0);
									}
								}}
							/>
							<p className="exemption-ownership-field-owner-text">% Owner</p>
						</div>
					</div>
					<div>
						<Label className="exemption-ownership-field-input-label">
							<span className="no-translate">
								{additionalOwnerFirstNameValue}'s
							</span>{" "}
							Ownership %
						</Label>
						<div className="exemption-ownership-field-input-wrapper">
							<TextField
								required
								placeholder={ownersValue === "Own With Spouse" ? "100" : "50"}
								type="number"
								maxLength={3}
								value={ownerTwoValue === 0 ? "" : ownerTwoValue ?? ""}
								onChange={e => {
									if (e.target.value.length <= 3) {
										setOwnerTwoValue(parseInt(e.target.value) || 0);
									}
								}}
							/>
							<p className="exemption-ownership-field-owner-text">% Owner</p>
						</div>
					</div>
				</div>
			</div>
			<ButtonV2
				size="large"
				disabled={ownerOneValue === undefined || ownerTwoValue === undefined}
				type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default OwnershipPercent;
